var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconGenerate = function SvgIconGenerate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#D4D4D4",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M17.413 6.382 15.45 4.423a.833.833 0 0 0-1.18.004L3.692 15.106a.833.833 0 0 0 .004 1.176l1.96 1.959a.833.833 0 0 0 1.182-.004L17.416 7.558a.833.833 0 0 0-.003-1.176Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D4D4D4",
    strokeWidth: 1.5,
    d: "m11.667 7.168 2.917 2.917"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D4D4D4",
    strokeWidth: 1.2,
    d: "M4.922 2.38a.083.083 0 0 1 .156 0l.81 2.185q.013.035.049.05l2.185.808a.083.083 0 0 1 0 .156l-2.185.81a.08.08 0 0 0-.05.049l-.809 2.185a.083.083 0 0 1-.156 0l-.809-2.185a.08.08 0 0 0-.049-.05L1.878 5.58a.083.083 0 0 1 0-.156l2.186-.809a.08.08 0 0 0 .05-.049z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D4D4D4",
    strokeWidth: 0.9,
    d: "M15.422 13.711a.083.083 0 0 1 .156 0l.584 1.578q.013.035.05.05l1.577.583a.083.083 0 0 1 0 .156l-1.578.584a.08.08 0 0 0-.05.05l-.583 1.577a.083.083 0 0 1-.156 0l-.584-1.578a.08.08 0 0 0-.05-.05l-1.577-.583a.083.083 0 0 1 0-.156l1.578-.584a.08.08 0 0 0 .05-.05z"
  })));
};
export default SvgIconGenerate;